import { FunctionComponent } from "react";

import { Link } from "react-router-dom";

import { format } from "date-fns";

import { faList } from "@fortawesome/pro-regular-svg-icons";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import { Icon } from "@/components";

import { ROUTE_CONFIG } from "@/routes/config";

export const PersonOnList: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	return (
		<div className="flex flex-row gap-2 items-center min-w-0 w-full overflow-hidden">
			<Tooltip
				className="min-w-0 overflow-hidden"
				content={
					<>
						<b>{row.list.name}</b> added on {format(new Date(row.createdAt), "HH:mm dd.MM.yyyy")}
						<br />
						Click to view list
					</>
				}
			>
				<Link
					className="min-w-0 overflow-hidden"
					target="_blank"
					to={`${ROUTE_CONFIG.LISTS_DETAIL}/${
						row.list.id
					}?tab=UNASSIGNED&searchTerm=${encodeURIComponent(row.prospect?.name ?? "")}`}
				>
					<div className="hover:underline  flex flex-row items-center gap-1 text-sm text-left min-w-0 overflow-hidden">
						<Icon className="text-gray-500  w-3 h-3  shrink-0" icon={faList} />
						<span className="truncate text-status-info">{row.list.name}</span>
					</div>
				</Link>
			</Tooltip>
		</div>
	);
};
